import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EventScheduleResponse, EventClassResponse } from '../../../../../../../../../../@shared/models/response.module';

@Component({
  selector: 'app-start-live-modal',
  standalone: false,
  templateUrl: './start-live-modal.html',
  styleUrl: './start-live-modal.css'
})
export class StartLiveModal {
  @Input() schedule: EventScheduleResponse;
  @Input() eventClass: EventClassResponse;

  constructor(public activeModal: NgbActiveModal) {}

  get participantCount(): number {
    return this.schedule?.entries?.filter(e => e.entry_type === 'participant').length || 0;
  }

  get timePerEntry(): string {
    const seconds = this.schedule?.time_per_entry_seconds || 0;
    if (seconds >= 3600) {
      const hours = Math.floor(seconds / 3600);
      const mins = Math.floor((seconds % 3600) / 60);
      return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    }
    return `${Math.floor(seconds / 60)} min`;
  }

  get estimatedDuration(): string {
    // Calculate total duration including all entries (participants + breaks)
    let totalSeconds = 0;
    const entries = this.schedule?.entries || [];

    for (const entry of entries) {
      if (entry.entry_type === 'break') {
        // Add break duration
        totalSeconds += entry.duration_seconds || 0;
      } else if (entry.entry_type === 'participant') {
        // Add participant duration
        totalSeconds += entry.duration_seconds || this.schedule?.time_per_entry_seconds || 0;
      }
    }

    if (totalSeconds >= 3600) {
      const hours = Math.floor(totalSeconds / 3600);
      const mins = Math.floor((totalSeconds % 3600) / 60);
      return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    }
    return `${Math.floor(totalSeconds / 60)} min`;
  }

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
